export const groupBy =(data, key) => {
  return data.reduce((element, index) => {
    (element[index[key]] = element[index[key]] || []).push(index);
    return element;
  }, {})
}